import fetch from "isomorphic-fetch";
import { useState, useEffect } from "react";
import ArrowLink from "components/atoms/arrowLink/index.jsx";
import FormCol from "components/molecules/formCol";
import FormFieldset from "components/molecules/formFieldset";
import FormTextField from "components/molecules/formTextField";
import { currency, getDiscountAmount } from "helpers/format.js";
import "./styles.scss";

const ValidatePromotionCode = ({
  withCopy,
  onSuccess,
  defaultCode = "",
  vehicle,
}) => {
  const [code, setCode] = useState(defaultCode);
  const [promotion, setPromotion] = useState(null);
  const [valid, setValid] = useState(undefined);

  const validate = () => {
    setValid(undefined);

    fetch(
      `https://territorioyacopini.com.ar/api/used-promotion?code=${code}&stock_id=${vehicle.id}`
    )
      .then((response) => response.json())
      .then(({ data }) => {
        if (!data) {
          setValid(false);
          setPromotion(null);
          return;
        }

        if (onSuccess) {
          onSuccess(data);
        }

        sessionStorage.setItem("coupon", code);
        setValid(true);
        setPromotion(data);
      });
  };

  useEffect(() => {
    if (code) {
      validate();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="promotionCode">
      <FormFieldset>
        {!valid && (
          <>
            <FormCol first="true">
              <h4>Cupón de descuento</h4>
              <p className="b">
                Si tenés un cupón, ingresa el código a continuación y confirmá
                su validez y descuento.
              </p>
              <br />
            </FormCol>
            <FormCol>
              <FormTextField
                label="Cupón de descuento"
                type="text"
                value={code}
                onChange={(e) => setCode(e.currentTarget.value)}
                onBlur={validate}
                placeholder="AABBCC"
              />
              {valid === false && (
                <>
                  <div className="FormError">
                    El cupón no es válido o ha vencido.
                  </div>
                  <br />
                </>
              )}
              <ArrowLink onClick={validate}>Validar Cupón</ArrowLink>
            </FormCol>
          </>
        )}
        {valid && promotion && (
          <div className="FormSuccess">
            <h4>¡Tu cupón es válido!</h4>
            <p className="b">
              Podés pasar a reservar el vehículo online y aplicarlo en el último
              paso para obtener el beneficio.
            </p>
            <br />
            <p className="b">
              Precio del vehículo: {currency(vehicle.full_price)}
            </p>
            <p className="b">
              Descuento aplicado: -{" "}
              {currency(getDiscountAmount(vehicle, promotion))}
            </p>
            <p className="b">
              <strong>
                Precio Final:{" "}
                {currency(
                  vehicle.full_price - getDiscountAmount(vehicle, promotion)
                )}
              </strong>
            </p>
          </div>
        )}
      </FormFieldset>
    </div>
  );
};

export default ValidatePromotionCode;
